import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-pl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-pl.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { MapService } from "../../../../../map/shared/map.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import Query from "@arcgis/core/rest/support/Query";
import { CreateApplicationLocationPlConstants } from "./create-application-location-pl.constants";
import { MapTools } from "../../../../../map/shared/map.tools";
import GeometryUtils from "../../../../../shared/utils/geometry-utils";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { debounceTime } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationLocationPlComponent = class CreateApplicationLocationPlComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    requestStatusService;
    mapService;
    mapTools;
    changeDetectorRefs;
    active;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationPlConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationPlConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationPlConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationPlConstants.DESCRIPTION_LABEL_4;
    descriptionLabel5 = CreateApplicationLocationPlConstants.DESCRIPTION_LABEL_5;
    validationMessages = CreateApplicationLocationPlConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationPlConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationPlConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationPlConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationPlConstants.FARM_NO_CONTROL;
    zoningControl = CreateApplicationLocationPlConstants.ZONING_CONTROL;
    streetNumberControl = CreateApplicationLocationPlConstants.STREET_NO_CONTROL;
    streetNameControl = CreateApplicationLocationPlConstants.STREET_NAME_CONTROL;
    townControl = CreateApplicationLocationPlConstants.TOWN_CONTROL;
    sgCodeControl = CreateApplicationLocationPlConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationPlConstants.ADDRESS_CONTROL;
    ownerControl = CreateApplicationLocationPlConstants.OWNER_CONTROL;
    leaseAreaControl = CreateApplicationLocationPlConstants.LEASE_AREA_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationPlConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationPlConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationPlConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationPlConstants.FARM_NO_TEXT_PLACEHOLDER;
    zoningControlTextPlaceHolder = CreateApplicationLocationPlConstants.ZONING_TEXT_PLACEHOLDER;
    streetNumberTextPlaceHolder = CreateApplicationLocationPlConstants.STREET_NO_TEXT_PLACEHOLDER;
    streetNameTextPlaceHolder = CreateApplicationLocationPlConstants.STREET_NAME_TEXT_PLACEHOLDER;
    townTextPlaceHolder = CreateApplicationLocationPlConstants.TOWN_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationPlConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationPlConstants.ADDRESS_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    ownerLabel = CreateApplicationLocationPlConstants.OWNER_LABEL;
    copyApplicantToOwnerZoneLabel = CreateApplicationLocationPlConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = CreateApplicationLocationPlConstants.REMOVE_PROPERTY_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerListLabel = "";
    mapComponent;
    sketch;
    isMapLoaded = false;
    selectedPropertySubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, appController, requestStatusService, mapService, mapTools, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.requestStatusService = requestStatusService;
        this.mapService = mapService;
        this.mapTools = mapTools;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToProperty();
        if (this.createApplicationService.propertyData) {
            this.loadExistingProperty(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.sketch = this.mapTools.getMapTool("drawTool");
        const appType = this.aflaModuleStrategyService.form.get("detailsForm").get("applicationType").value;
        if (appType !== null && appType.value === "Lease") {
            this.mapTools.expandWidget("drawTool");
            this.sketch.create("polygon");
        }
        this.sketch.on("create", (event) => {
            if (event.state === "start") {
                this.mapService.showPopups = false;
            }
            if (event.state === "complete") {
                this.mapService.showPopups = true;
                if (event.graphic.geometry.type === "polygon") {
                    this.propertiesForm.get("leaseArea").setValue(event.graphic.geometry);
                }
            }
            else if (event.state === "cancel") {
                this.mapService.showPopups = true;
            }
            else {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
        if (this.propertiesForm.get("leaseArea").value !== null) {
            this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(this.propertiesForm.get("leaseArea").value)], "Draw Tool Layer");
        }
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
        if (this.appController.moduleSimulateMode) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
        }
        else {
            this.ownerGroups = stepMeta.ownerGroup;
            if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
                this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
            }
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyApplicantToOwnerClicked(propertyIndex) {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        const previoursActiveIndex = this.active;
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
        if (previoursActiveIndex === propertyIndex && propertyIndex > 0) {
            this.active = propertyIndex - 1;
        }
        else if (previoursActiveIndex > propertyIndex) {
            this.active = previoursActiveIndex - 1;
        }
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    loadExistingProperty(property) {
        this.setPropertyData(property, property.geometry);
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationPlConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                zoning: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Zoning", "zoning"), [Validators.required]),
                streetNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "StreetNumber", "streetnumber"), [Validators.required]),
                streetName: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "StreetName", "streetname"), [Validators.required]),
                town: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Town", "town"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                owners: new FormControl(null)
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
                .pipe(takeUntil(this._destroy$), take(1))
                .subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    this.getPropertyOwners(sgCode, newProperty);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(CreateApplicationLocationPlConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                name: item.attributes.Name ? item.attributes.Name : item.attributes.name,
                                surname: item.attributes.Surname ? item.attributes.Surname : item.attributes.surname,
                                telephone: item.attributes.Telephone ? item.attributes.Telephone : item.attributes.telephone,
                                email: item.attributes.Email ? item.attributes.Email : item.attributes.email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod ? item.attributes.DefaultCommunicationMethod : item.attributes.defaultcommunicationmethod,
                                postalAddress: item.attributes.PostalAddress ? item.attributes.PostalAddress : item.attributes.postaladdress,
                                designation: item.attributes.Designation ? item.attributes.Designation : item.attributes.designation,
                                organisation: item.attributes.Organisation ? item.attributes.Organisation : item.attributes.organisation,
                                clientVatNumber: item.attributes.ClientVatNumber ? item.attributes.ClientVatNumber : item.attributes.clientvatnumber,
                                streetAddress: item.attributes.StreetAddress ? item.attributes.StreetAddress : item.attributes.streetaddress,
                                homePhone: item.attributes.Homephone ? item.attributes.Homephone : item.attributes.homephone,
                                idNumber: item.attributes.IDNumber ? item.attributes.IDNumber : item.attributes.idnumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber ? item.attributes.OrganisationRegistrationNumber : item.attributes.organisationregistrationnumber,
                                representative: item.attributes.Representative ? item.attributes.Representative : item.attributes.representative,
                                fax: item.attributes.Fax ? item.attributes.Fax : item.attributes.fax,
                                cellphone: item.attributes.Cellphone ? item.attributes.Cellphone : item.attributes.cellphone,
                                streetSuburb: item.attributes.StreetSuburb ? item.attributes.StreetSuburb : item.attributes.streetsuburb,
                                streetCity: item.attributes.StreetCity ? item.attributes.StreetCity : item.attributes.streetcity,
                                streetProvince: item.attributes.StreetProvince ? item.attributes.StreetProvince : item.attributes.streetprovince,
                                streetCode: item.attributes.StreetCode ? item.attributes.StreetCode : item.attributes.streetcode,
                                postalSuburb: item.attributes.PostalSuburb ? item.attributes.PostalSuburb : item.attributes.postalsuburb,
                                postalCity: item.attributes.PostalCity ? item.attributes.PostalCity : item.attributes.postalcity,
                                postalProvince: item.attributes.PostalProvince ? item.attributes.PostalProvince : item.attributes.postalprovince,
                                postalCode: item.attributes.PostalCode ? item.attributes.PostalCode : item.attributes.postalcode,
                                postalCountry: item.attributes.PostalCountry ? item.attributes.PostalCountry : item.attributes.postalcountry,
                                streetCountry: item.attributes.StreetCountry ? item.attributes.StreetCountry : item.attributes.streetcountry,
                                professionalBody: item.attributes.ProfessionalBody ? item.attributes.ProfessionalBody : item.attributes.professionalbody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber ? item.attributes.ProfessionalBodyRegistrationNumber : item.attributes.professionalbodyregistrationumber,
                                groups: []
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(CreateApplicationLocationPlConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                const propertyControl = this.getProperties();
                const propertyIndex = propertyControl.length;
                propertyControl.push(newProperty);
                this.active = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                this.changeDetectorRefs.detectChanges();
                if (owners.length > 0) {
                    this.recipientListService.setRecipients(owners, true, ownersControl);
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            const propertyControl = this.getProperties();
            const propertyIndex = propertyControl.length;
            propertyControl.push(newProperty);
            this.active = propertyControl.length - 1;
            this.updateRequiredFields(propertyIndex);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Property and lease graphics", true);
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: RequestStatusService },
        { type: MapService },
        { type: MapTools },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationPlComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-location-pl",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationPlComponent);
export { CreateApplicationLocationPlComponent };
